import ContainerHome24 from '@/components/atoms/ContainerHome24';
import React from 'react';
import Styles from './CanaisAtendimentoAreaCliente.css';
import RedButton from '@/components/atoms/RedButton';

function CanaisAtendimentoAreaCliente({ show }) {
  return (
    <>
      <section id="canais-atendimento-area-cliente" className={show ? 'show' : ''}>
        <ContainerHome24>
          <p className="area-cliente-paragrafo">
            É a área exclusiva para nossos clientes, dedicada somente para quem já possui
            financiamento ou proposta com a gente.
            <br className="is-mob" /> <br className="is-mob" /> Para acessar é necessário inserir o
            CPF e a senha cadastrados.
          </p>
          <RedButton
            href="https://www.santanderfinanciamentos.com.br/spa-mktfinweb/#/login?int_source=portalSF&int_medium=canais-de-atendimento:area-do-cliente&int_campaign=acessar"
            target="_blank"
            className="area-cliente-btn"
          >
            Acessar área do cliente
          </RedButton>

          <div className="area-cliente-boxes is-mob">
            <div className="area-cliente-box">
              <img
                className="area-cliente-box-img"
                src="assets/canais-de-atendimento/ic_barcode.svg"
                alt="boleto"
              />
              <p className="area-cliente-box-paragrafo">
                2ª via de <br /> boletos
              </p>
            </div>
            <div className="area-cliente-box">
              <img
                className="area-cliente-box-img"
                src="assets/canais-de-atendimento/ic_checking_account_change.svg"
                alt="comprovante de pagamento"
              />
              <p className="area-cliente-box-paragrafo">
                Comprovante
                <br /> de pagamento
              </p>
            </div>
            <div className="area-cliente-box">
              <img
                className="area-cliente-box-img"
                src="assets/canais-de-atendimento/ic_std_financing_reseller.svg"
                alt="boleto"
              />
              <p className="area-cliente-box-paragrafo">
                Renegociar
                <br /> dívidas
              </p>
            </div>
            <div className="area-cliente-box">
              <img
                className="area-cliente-box-img"
                src="assets/canais-de-atendimento/ic_calendar.svg"
                alt="boleto"
              />
              <p className="area-cliente-box-paragrafo">
                Antecipar
                <br /> parcelas
              </p>
            </div>
            <div className="area-cliente-box">
              <img
                className="area-cliente-box-img"
                src="assets/canais-de-atendimento/ic_levy_sent.svg"
                alt="boleto"
              />
              <p className="area-cliente-box-paragrafo">
                Quitar
                <br /> contrato
              </p>
            </div>
            <div className="area-cliente-box">
              <img
                className="area-cliente-box-img"
                src="assets/canais-de-atendimento/ic_checking_account_change.svg"
                alt="alterar forma de pagamento"
              />
              <p className="area-cliente-box-paragrafo">
                Alterar forma de
                <br /> pagamento
              </p>
            </div>
          </div>

          <div className="area-cliente-content-desk">
            <div className="area-cliente-boxes is-desk">
              <div className="area-cliente-box">
                <img
                  className="area-cliente-box-img"
                  src="assets/canais-de-atendimento/ic_barcode.svg"
                  alt="boleto"
                />
                <p className="area-cliente-box-paragrafo">
                  2ª via de <br /> boletos
                </p>
              </div>
              <div className="area-cliente-box">
                <img
                  className="area-cliente-box-img"
                  src="assets/canais-de-atendimento/ic_checking_account_change.svg"
                  alt="comprovante de pagamento"
                />
                <p className="area-cliente-box-paragrafo">
                  Comprovante
                  <br /> de pagamento
                </p>
              </div>
              <div className="area-cliente-box">
                <img
                  className="area-cliente-box-img"
                  src="assets/canais-de-atendimento/ic_std_financing_reseller.svg"
                  alt="boleto"
                />
                <p className="area-cliente-box-paragrafo">
                  Renegociar
                  <br /> dívidas
                </p>
              </div>
              <div className="area-cliente-box">
                <img
                  className="area-cliente-box-img"
                  src="assets/canais-de-atendimento/ic_calendar.svg"
                  alt="boleto"
                />
                <p className="area-cliente-box-paragrafo">
                  Antecipar
                  <br /> parcelas
                </p>
              </div>
              <div className="area-cliente-box">
                <img
                  className="area-cliente-box-img"
                  src="assets/canais-de-atendimento/ic_levy_sent.svg"
                  alt="boleto"
                />
                <p className="area-cliente-box-paragrafo">
                  Quitar
                  <br /> contrato
                </p>
              </div>
              <div className="area-cliente-box">
                <img
                  className="area-cliente-box-img"
                  src="assets/canais-de-atendimento/ic_checking_account_change.svg"
                  alt="alterar forma de pagamento"
                />
                <p className="area-cliente-box-paragrafo">
                  Alterar forma de
                  <br /> pagamento
                </p>
              </div>
            </div>

            <div className="area-cliente-notebook is-desk">
              <img
                className="area-cliente-notebook-img"
                src="assets/canais-de-atendimento/notebook-desk.svg"
                alt="notebook para acessar a área do cliente da Financiamentos Santander"
              />
              {/* <img
                className="area-cliente-santander-img"
                src="assets/canais-de-atendimento/santander-desk.svg"
                alt="logo santander"
              /> */}
            </div>
          </div>
        </ContainerHome24>
        <div className="area-cliente-notebook is-mob">
          <img
            className="area-cliente-notebook-img"
            src="assets/canais-de-atendimento/notebook.svg"
            alt="notebook para acessar a área do cliente da Financiamentos Santander"
          />
          {/* <img
            className="area-cliente-santander-img"
            src="assets/canais-de-atendimento/Santander.svg"
            alt="logo santander"
          /> */}
        </div>
        <style jsx>{Styles}</style>
      </section>
    </>
  );
}

export default CanaisAtendimentoAreaCliente;
